/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const CircularOptionPickerContext = createContext({});
//# sourceMappingURL=circular-option-picker-context.js.map